<template>
    <div class="submission-explain">
        <h1 class="submission-explain__title"></h1>
        <ul class="submission-explain__lists">
            <li class="submission-explain__list">
                <div class="submission-explain__list-box">
                    <h2 class="submission-explain__list-title">2절대</h2>
                    <p>초릿대 / 버트대(손잡이)로 이루어진 낚싯대, 가운데서 분리되는 낚싯대입니다. 부러진해당 절반만 보내시고 나머지는 고객 보관 바랍니다. </p>
                    <p class="small color-red">ex) 닉스팝2 / 닉스인쇼어 등</p>
                    <img src="/images/sub/inquiry/sample-image-1.jpg" alt="">
                </div>
            </li>
            <li class="submission-explain__list">
                <div class="submission-explain__list-box">
                    <h2 class="submission-explain__list-title">BUTT 분리형</h2>
                    <p>손잡이 분리형 낚싯대로 전체 보내주셔야 보증처리 가능합니다.</p>
                    <p class="small color-red">ex) CXT시리즈 / C4시리즈 / AIR일부 제품</p>
                    <img src="/images/sub/inquiry/sample-image-2.jpg" alt="">
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default{
}
</script>
<style lang="scss" scoped>
.submission-explain{
    padding: 76px 60px; background: #f9f9f9;
    p { margin: 10px 0; font-size: 18px; }
    p.small { font-size: 14px; }
    &__title { line-height: 1; text-align: center; font-size: 36px; }
    &__lists { margin-left: 25px; list-style-type: square; color: #ef8009; }
    &__list { margin-bottom: 50px; font-size: 24px; }
    &__list:last-child { margin-bottom: 0; }
    &__list-box { color: #222222; }
    &__list-title { line-height: 1; font-size: 24px; }
}
@media(max-width:1200px){
    .submission-explain{
        padding: 76px 60px;
        p { font-size: 14px; }
        p.small { font-size: 12px; }
        &__lists { margin-left: 20px; }
        &__list { margin-bottom: 36px; font-size: 18px; }
        &__list-title { font-size: 18px; }
    }
}
@media(max-width:768px){
    .submission-explain{
        padding: 36px 24px;
    }
}
</style>